export type SupportArticleIndexEntry = {
  file: string;
  slug: string;
  categoryKey: string;
  categoryTitle: string;
  order: number;
};

export type SupportArticleCategory = {
  key: string;
  title: string;
  files: string[];
};

export const supportArticleCategories: SupportArticleCategory[] = [
  {
    key: 'getting-started',
    title: 'Getting Started',
    files: [
      'sign_in_create_account.md',
      'signup_redirect_explained.md',
      'reset_password.md',
      'choose_plan_and_checkout.md',
      'checkout_success_next_steps.md',
    ],
  },
  {
    key: 'concepts-essentials',
    title: 'Concepts and Essentials',
    files: [
      'translation_vs_proofreading.md',
      'what_is_processing_status.md',
      'what_is_processing_status_vs_dashboard.md',
      'what_is_ai_glossary_scan.md',
      'what_is_book_dashboard.md',
      'what_are_translation_flags.md',
      'what_are_language_pairs.md',
      'what_is_add_language.md',
      'what_is_word_count_and_why_it_matters.md',
      'what_are_always_never_translate_rules.md',
      'what_is_series_defaults.md',
      'what_is_credit_history.md',
      'what_is_export_history.md',
      'what_is_beta_access.md',
      'subscription_credits_vs_forever_credits.md',
      'platform_overview.md',
    ],
  },
  {
    key: 'library-books',
    title: 'Library and Books',
    files: [
      'manage_books_library_overview.md',
      'upload_a_book.md',
      'book_detail_overview.md',
      'book_dashboard_next_steps.md',
      'replace_a_manuscript.md',
    ],
  },
  {
    key: 'translation-proofreading',
    title: 'Translation and Proofreading',
    files: [
      'apply_updated_french_dialog_rules.md',
      'translate_a_chapter.md',
      'proofread_a_chapter.md',
      'track_translation_progress.md',
      'ai_glossary_scan_and_review.md',
    ],
  },
  {
    key: 'faqs-troubleshooting',
    title: 'FAQs and Troubleshooting',
    files: [
      'faq_why_translate_is_blocked.md',
      'faq_should_i_disable_character_analysis_before_translation.md',
      'faq_why_glossary_scan_is_required.md',
      'faq_why_flags_show_loading.md',
      'faq_why_a_job_looks_stuck.md',
      'faq_why_audiobook_creation_failed.md',
      'faq_why_export_is_delayed.md',
      'faq_why_renew_now_is_disabled.md',
      'faq_missing_language_or_model.md',
      'faq_why_file_upload_failed.md',
      'faq_replace_manuscript_blocked.md',
      'faq_credits_look_wrong.md',
      'faq_do_subscription_credits_roll_over.md',
      'faq_can_i_upgrade_or_downgrade_anytime.md',
      'faq_do_plan_changes_affect_credit_expiration.md',
      'faq_what_happens_if_content_is_rejected.md',
      'faq_am_i_charged_for_rejected_or_failed_chapters.md',
      'faq_can_i_translate_non_book_content.md',
      'faq_is_my_book_used_for_ai_training_or_kept_after_deletion.md',
      'faq_can_i_add_missing_chapters_or_edit_text_without_reuploading_everything.md',
      'faq_will_translate_book_charge_again_for_already_translated_chapters.md',
      'faq_what_happens_when_i_delete_translated_or_proofread_chapters.md',
      'faq_do_i_need_human_review_after_scribeshadow.md',
      'faq_why_dont_i_see_apply_updated_french_dialog_rules.md',
      'faq_should_i_use_free_cleanup_or_discounted_retranslation.md',
      'faq_when_does_my_subscription_renew.md',
      'faq_why_dialog_punctuation_is_mixed.md',
      'faq_how_to_fix_mixed_dialog_punctuation.md',
      'faq_where_is_my_translated_chapter.md',
      'faq_why_amazon_flags_german_spelling.md',
      'faq_why_french_has_spaces_before_punctuation.md',
      'faq_german_quotes_vs_guillemets.md',
      'faq_how_to_improve_translated_keywords.md',
      'faq_will_word_formatting_be_preserved.md',
      'faq_what_file_formats_can_i_export.md',
      'faq_what_is_the_referral_program.md',
      'faq_how_do_i_get_a_referral_code.md',
      'faq_where_can_i_find_my_referral_code.md',
      'faq_what_do_we_get_from_referral_code.md',
      'faq_can_referral_code_be_used_on_any_plan.md',
      'faq_who_can_use_my_referral_code.md',
      'faq_how_do_i_earn_referral_credits.md',
      'faq_can_referral_code_be_combined_with_promotions.md',
      'faq_i_dont_see_my_referral_credits.md',
    ],
  },
  {
    key: 'metadata-marketing',
    title: 'Metadata and Marketing',
    files: [
      'edit_book_metadata.md',
      'translate_book_metadata.md',
      'generate_blurbs_and_keywords.md',
      'create_marketing_videos.md',
      'generate_or_translate_cover_art.md',
      'publishing_checklist.md',
    ],
  },
  {
    key: 'audiobooks-exports',
    title: 'Audiobooks and Exports',
    files: [
      'create_audiobook.md',
      'download_or_export_audiobook_files.md',
      'export_book_files.md',
      'export_character_data.md',
    ],
  },
  {
    key: 'account-billing',
    title: 'Account and Billing',
    files: [
      'account_faq_overview.md',
      'billing_overview_and_credits.md',
      'manage_subscription.md',
      'on_break_plan.md',
      'update_account_settings.md',
      'view_credit_history.md',
      'promo_codes.md',
      'referrals.md',
      'gifts.md',
    ],
  },
  {
    key: 'series-beta',
    title: 'Series and Beta Programs',
    files: [
      'manage_series_defaults.md',
      'join_or_leave_beta.md',
    ],
  },
  {
    key: 'surveys-support',
    title: 'Surveys and Support',
    files: [
      'language_survey_choose_languages.md',
      'language_survey_complete.md',
      'get_help_and_contact_support.md',
    ],
  },
];

export const supportArticleIndex: SupportArticleIndexEntry[] = (() => {
  let order = 0;
  return supportArticleCategories.flatMap((category) =>
    category.files.map((file) => {
      const entry = {
        file,
        slug: file.replace(/\.md$/, '').replace(/_/g, '-'),
        categoryKey: category.key,
        categoryTitle: category.title,
        order,
      };
      order += 1;
      return entry;
    }),
  );
})();

export const supportArticleBasePath = `${process.env.PUBLIC_URL || ''}/support-articles`;

export const supportArticlePath = (file: string) => `${supportArticleBasePath}/${file}`;
